import List from "./List.js";
import Create from "./Create.js";
import Edit from "./Edit.js";

export default { List, Create, Edit };
